const BASE_URL = process.env.CLIENT_API_URL || '';

export async function getSubscriptionById(id) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/getSubscriptionById?subscriptionId=${id}`,
  );
  if (!res.ok) {
    throw new Error('getSubscriptionById request error');
  }
  const { result } = await res.json();
  return result;
}

export async function getCustomerEmailById(customerId) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/getCustomerEmailById?customerId=${customerId}`,
  );
  if (!res.ok) {
    throw new Error('getCustomerEmailById request error');
  }
  const { result } = await res.json();
  return result.email;
}

export async function pauseSubscriptionById(subscriptionId) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/pauseSubscriptionById?subscriptionId=${subscriptionId}`,
  );
  if (!res.ok) {
    throw new Error('pauseSubscriptionById request error');
  }
}

export async function resumeSubscriptionById(subscriptionId) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/resumeSubscriptionById?subscriptionId=${subscriptionId}`,
  );
  if (!res.ok) {
    throw new Error('resumeSubscriptionById request error');
  }
}

export async function cancelSubscriptionById(subscriptionId) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/cancelSubscriptionById?subscriptionId=${subscriptionId}`,
  );
  if (!res.ok) {
    throw new Error('cancelSubscriptionById request error');
  }
}

export async function createCustomerPortalSession(customerId) {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/createCustomerPortalSession?customerId=${customerId}`,
  );
  if (!res.ok) {
    throw new Error('createCustomerPortalSession request error');
  }
  const data = await res.json();
  const url = data && data.message === 'success' && data.data.url;

  if (!url || typeof url !== 'string') {
    throw new Error('createCustomerPortalSession: URL not found in response');
  }

  return url;
}

export async function getHostingLastRunTime() {
  const res = await fetch(
    `${BASE_URL}/stats/subscription/getHostingLastRunTime`,
  );
  if (!res.ok) {
    throw new Error('getHostingLastRunTime request error');
  }
  const { result } = await res.json();
  return result;
}
